export default "__VITE_ASSET__BASMnLYs__"